import { H3, LI, SVG } from "../../../../AbstractElements";
import { Notifications } from "../../../../utils/Constant";
import ActivityUpdate from "./ActivityUpdate";
import { useState } from "react";

const NotificationHeader = () => {
  const [show, setShow] = useState(false)
  return (
    <LI className="onhover-dropdown" >
      <div className="notification-box">
        <SVG iconId="Bell" onClick={()=>setShow(!show)}/>
      </div>
      <div className={`onhover-show-div notification-dropdown ${show ? "show" : "" }`}>
        <H3 className="f-18 mb-0 dropdown-title"> {Notifications} </H3>
        <ActivityUpdate />
      </div>
    </LI>
  );
};

export default NotificationHeader;
